module.exports = __webpack_public_path__ + "media/images/woo3-b18a5e25be236ffacd6b45eb4558e368.png";